import * as ExcelJs from "exceljs";
import { jwtDecode } from "jwt-decode";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getChipColorByEtatCode = (etatCode) => {
  switch (etatCode) {
    case "NOU":
      return "primary";
    case "ANN":
    case "CLO":
    case "ENV":
    case "1":
    case "7":
      return "warning";
    case "2":
    case "SVM":
    case "SVM(Avispartiel)":
    case "SVM(Avistotal)":
    case "SVM(TranfertEffectue)":
    case "24":
      return "info";
    case "EAA":
    case "ACCADII":
    case "MOD":
    case "3":
    case "5":
    case "VISA":
    case "9":
      return "success";
    case "REJADII":
    case "REJ":
    case "EAD":
    case "6":
    case "8":
    case "12":
    case "RECM":
    case "21":
      return "error";
    case "SMM":
    case "SMM(Avispartiel)":
    case "SMM(Avistotal)":
    case "SMM(TranfertEffectue)":
    case "4":
      return "info";
    case "SMD":
    case "SMA":
    case "10":
    case "11":
      return "info";
    default:
      return "primary";
  }
};

export const getChipColorByEtatCodeTi = (etatCode) => {
  switch (etatCode) {
    case "ALT":
      return "primary";
    case "RECB":
    case "RECM":
    case "RECA":
    case "REC":
    case "PDRF":
    case "DRF":
    case "ANRF":
    case "CRBA":
    case "RERF":
    case "RDDCE":
    case "REJADII":
      return "error";
    case "CON":
    case "CMCE":
    case "CBNQ":
    case "DOM":
    case "PDOM":
    case "ACCEPTADII":
    case "CBNA":
      return "success";
    case "DFIN":
    case "VISA":
    case "ECHU":
    case "REGLP":
    case "DOM_SOUMI_BAN":
    case "DOM_SOUMI_ADII":
    case "ECHU_SOUM_PROL":
      return "warning";
    case "APUR":
    case "FINA":
    case "CAN":
    case "MOD":
    case "REP":
    case "DOM_MODIF":
    case "REGL":
    case "SOUMI_MOD_DCE":
    case "SOUMI_MOD_ADII":
    case "ENVADII":
    case "ENV":
      return "info";
    default:
      return "primary";
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString();
};

export function recursiveFormatDate(dateString) {
  if (!dateString) return null;

  const formattedDate = new Date(dateString);

  return formattedDate;
}

export function recursiveFormatDateTI(dateString) {
  if (!dateString) return null;

  const FinDateParts = dateString?.split("/");
  dateString = `${FinDateParts[2]}/${FinDateParts[1]}/${FinDateParts[0]}`;
  const formattedDate = new Date(dateString);

  return formattedDate;
}

export const formattedDateFromDB = (dateString) => {
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
};

export const formattedDateTimeFromDB = (dateString) => {
  if (dateString === null) return null;

  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const time = date.toLocaleTimeString("fr-FR", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  const result = `${formattedDate} ${time}`;

  return result;
};

export const ExportLicences = (rows) => {
  const workBook = new ExcelJs.Workbook();
  const sheet = workBook.addWorksheet("Licences");
  sheet.properties.defaultRowHeight = 16;

  sheet.columns = [
    {
      header: "Nº d’enregistrement",
      key: "numEnrg",
      width: 22,
    },
    {
      header: "Date de création",
      key: "dateDebut",
      width: 18,
    },
    {
      header: "Catégorie de la licence",
      key: "categorie",
      width: 25,
    },
    {
      header: "Devise",
      key: "devise",
      width: 30,
    },
    {
      header: "Montant total en devise",
      key: "montant",
      width: 23,
    },
    {
      header: "Bureau douanier",
      key: "bureauD",
      width: 25,
    },
    {
      header: "Exportateur",
      key: "exportateur",
      width: 25,
    },
    {
      header: "Déclarant",
      key: "declarant",
      width: 18,
    },
    {
      header: "Etat",
      key: "etat",
      width: 28,
    },
    {
      header: "Pays Destination",
      key: "paysDest",
      width: 25,
    },
    {
      header: "Ville Exportateur",
      key: "villeExp",
      width: 18,
    },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "25384a" },
    };
    cell.font = {
      family: 4,
      size: 12,
      bold: true,
      color: { argb: "FFFFFF" },
    };
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  rows.map((row) => {
    const paysDestinationArray = row?.origcountry?.map((origcount) => {
      return origcount?.nationality?.description;
    });
    sheet.addRow({
      numEnrg: row?.numRegistre,
      dateDebut: formattedDateTimeFromDB(row?.registrationDate),
      categorie: row?.exportTitleType?.code,
      devise: row?.currencyType?.description,
      montant: row?.totalQuantity.toString(),
      bureauD: row?.customsOffice?.description,
      exportateur: row?.operatorImpExp?.description,
      declarant: row?.freightForwarder?.description,
      etat: row?.typeStateTitleExp?.description,
      paysDest: paysDestinationArray ? paysDestinationArray.join(", ") : "",
      villeExp: row?.operatorImpExp?.ville?.description,
    });
  });

  workBook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.speadsheet.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Licences(LE).xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const ExportTitres = (rows) => {
  const workBook = new ExcelJs.Workbook();
  const sheet = workBook.addWorksheet("Titres");
  sheet.properties.defaultRowHeight = 16;

  sheet.columns = [
    {
      header: "Nº d’enregistrement",
      key: "numEnrg",
      width: 25,
    },
    {
      header: "Date de création",
      key: "dateDebut",
      width: 18,
    },
    {
      header: "Catégorie du titre",
      key: "categorie",
      width: 20,
    },
    {
      header: "Devise",
      key: "devise",
      width: 25,
    },
    {
      header: "Montant total en devise",
      key: "montant",
      width: 23,
    },
    {
      header: "Importateur",
      key: "importateur",
      width: 25,
    },
    {
      header: "Déclarant",
      key: "declarant",
      width: 18,
    },
    {
      header: "Banque",
      key: "banque",
      width: 18,
    },
    {
      header: "Date de domiciliation",
      key: "dateDom",
      width: 18,
    },
    {
      header: "N° de domiciliation",
      key: "numDom",
      width: 18,
    },
    {
      header: "Etat",
      key: "etat",
      width: 28,
    },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "25384a" },
    };
    cell.font = {
      family: 4,
      size: 12,
      bold: true,
      color: { argb: "FFFFFF" },
    };
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  rows.map((row) => {
    sheet.addRow({
      numEnrg: row?.numEnregistrement?.toString(),
      dateDebut: formattedDateTimeFromDB(row?.dateEnregistrement)?.toString(),
      categorie: row?.typeTitreImportation?.code?.toString(),
      devise: row?.typeDevise?.description?.toString(),
      montant: parseFloat(row?.montantTotal).toFixed(2)?.toString(),
      importateur:
        row?.operateurImportateurExportateur?.description?.toString(),
      declarant: row?.transitaire?.description?.toString(),
      banque: row?.banqueDescription,
      dateDom: formattedDateTimeFromDB(
        row?.domiciliacionBancaria?.dateDebutValiditee
      )?.toString(),
      numDom: row?.numDomiciliation?.toString(),
      etat: row?.etatDescription?.toString(),
    });
  });

  workBook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.speadsheet.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Titres(TI).xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const getAuth = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    return decoded;
  } else {
    return null;
  }
};

export const preparePayloadEtatTable = (columnsState, density, module) => {
  const activatedFields = Object.entries(columnsState)
    ?.filter(([key, value]) => value)
    .map(([key]) => key)
    .join(",");

  return {
    activatedField: activatedFields,
    density: density,
    module: module,
  };
};

export const getRoles = () => {
  const token = localStorage.getItem("token");
  let roles = [];
  if (token) {
    const decoded = jwtDecode(token);
    roles = decoded.roles?.filter((role) =>
      [
        "ROLE_VUPORTUARIA_ADMIN",
        "ROLE_VUPORTUARIA_BANCO",
        "ROLE_VUPORTUARIA_ANP",
      ]?.includes(role)
    );
  }
  return roles;
};

export const hasAnyRole = (roles) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const userRoles = decodedToken.roles;
    const hasMatchingRole = roles.some((role) => userRoles?.includes(role));
    return hasMatchingRole;
  } catch (error) {
    return false;
  }
};

export const getBankLogo = (codigo) => {
  switch (codigo) {
    case "002":
      return require("../../assets/images/arab-bank.png");
    case "007":
      return require("../../assets/images/attijariwafa-bank.png");
    case "011":
      return require("../../assets/images/bankOfAfrica.png");
    case "013":
      return require("../../assets/images/BMCI.png");
    case "021":
      return require("../../assets/images/creditDuMaroc.png");
    case "022":
      return require("../../assets/images/saham-bank.png");
    case "040":
      return require("../../assets/images/portnetLogo.png");
    case "225":
      return require("../../assets/images/creditAgricole.png");
    case "230":
      return require("../../assets/images/cih-Bank.png");
    case "350":
      return require("../../assets/images/albarid-bank.png");
    case "005":
      return require("../../assets/images/portnetLogo.png");
    case "003":
      return require("../../assets/images/Caixa.png");
    case "028":
      return require("../../assets/images/city.png");
    case "045":
      return require("../../assets/images/alAmal-bank.png");
    case "048":
      return require("../../assets/images/MediaFinanance-Bank.png");
    case "070":
      return require("../../assets/images/sabadell.png");
    case "362":
      return require("../../assets/images/assfa-bank.png");
    case "054":
      return require("../../assets/images/cdgCapital.png");
    case "101":
    case "127":
    case "117":
    case "143":
    case "145":
    case "148":
    case "150":
    case "157":
    case "164":
    case "181":
    case "190":
      return require("../../assets/images/banquePopulaire.png");
    case "050":
      return require("../../assets/images/cfg-Bank.png");
    case "310":
      return require("../../assets/images/TGR.png");
    case "367":
      return require("../../assets/images/portnetLogo.png");
    case "365":
      return require("../../assets/images/Al-akhdar-Bank.png");
    case "360":
      return require("../../assets/images/Umnia-Bank.png");
    default:
      return require("../../assets/images/portnetLogo.png");
  }
};
